
/**
 * @summary - Component that Provides Stock Update Edit Tab
 * @author Yuvasri S
 * @since 2024-07-26
 */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { DefaultCard } from '../../assets/styled-components/card';
import { Box, Button, Grid } from '@mui/material';
import CustomTextField from '../commoncomponents/CustomTextField';
import CustomFooter from '../commoncomponents/CustomFooter';
import { MasterGraph } from "../../utility/apiURLS";
import {
    getAuthToken,
} from "../../utility/tokenUtility";
import axios from "axios";
import { updateCreateStockRegister, updateStockUpdate, resetEditStockUpdate } from "../../redux/reducers/StockRegisterReducer/stockSlice";
import CustomDialog from '../commoncomponents/CustomDialog';
import { useNavigate } from "react-router";

const StockUpdateEditTab = ({ stockDetails, isViewMode, setUnsavedChanges }) => {
    const dispatch = useDispatch();
    const stockUpdate = useSelector((state) => state.stock.stockUpdate);

    const initialStockUpdateState = {
        updateQuantity: '',
        costPerPieces: '',
        remarks: '',
    };


    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const {
        itemcodeId,
        itemcode,
        itemCodeDesc,
    } = stockDetails;

    const [upId, setUpId] = useState('');
    const navigate = useNavigate();

    const [errors, setErrors] = useState({
        updateQuantity: false,
    });

    const [errorMessages, setErrorMessages] = useState({
        updateQuantity: "",
    });
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [succesDialogMessage, setSuccessDialogMessage] = useState('');
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

    const fetchStockUpdate = async (itemcodeId) => {
        try {
            const response = await axios.get(
                `${MasterGraph}/api/GraphStockRegister/GetStockRegisterupdatedetails/${itemcodeId}`,
                config
            );

            const stockUpdate = response.data[0];

            if (stockUpdate) {
                setUpId(stockUpdate.id);
                // dispatch(resetEditStockUpdate());

            } else {
                // dispatch(resetEditStockUpdate());
                // dispatch(updateStockUpdate({
                //     updateQuantity: '',
                //     costPerPieces: '',
                //     remarks: '',
                // }));
                setUpId('');
            }
        } catch (error) {
            console.error("Error fetching item details:", error);
        }
    };

    useEffect(() => {
        if (itemcodeId) {
            fetchStockUpdate(itemcodeId);
        }
        else {
            dispatch(updateStockUpdate(initialStockUpdateState));
        }
    }, [itemcodeId, dispatch]);

    // Reset state on mount
    useEffect(() => {
        dispatch(resetEditStockUpdate());
    }, [dispatch]);

    // useEffect(() => {
    //     // If any of the form fields change, mark as having unsaved changes
    //     setUnsavedChanges(true);
    // }, [stockUpdate.updateQuantity, stockUpdate.costPerPieces, stockUpdate.remarks]);


    const handleSave = async () => {
        try {
            const payload = {
                id: upId,
                quantityupdate: stockUpdate.updateQuantity,
                costperpieces: stockUpdate.costPerPieces,
                remarks: stockUpdate.remarks
            };


            // PUT request
            const putUrl = `${MasterGraph}/api/GraphStockRegister/UpdateStock/${upId}`;
            await axios.put(putUrl, payload, config);
            setSuccessDialogMessage('Data updated successfully.');

            // Update state or dispatch actions as needed
            dispatch(updateStockUpdate({
                quantityUpdate: stockUpdate.quantityUpdate,
                costPerPieces: stockUpdate.costPerPieces,
                remarks: stockUpdate.remarks,
            }));
            // Open success dialog
            setSuccessDialogOpen(true);

        } catch (error) {
            console.error("Error updating stock update data:", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let formIsValid = true;
        const newErrors = {
            updateQuantity: false,
        };
        const newErrorMessages = {
            updateQuantity: "",
        };
        if (!stockUpdate.updateQuantity) {
            formIsValid = false;
            newErrors.updateQuantity = true;
            newErrorMessages.updateQuantity = "Update Quantity is required";
        }
        setErrors(newErrors);
        setErrorMessages(newErrorMessages);

        if (formIsValid) {
            handleSave();
            setHasUnsavedChanges(false);
            setUnsavedChanges(false);
        }
    };

    const handleCancel = () => {
        // if (hasUnsavedChanges && !isViewMode) {
        if (hasUnsavedChanges) {
            setCancelDialogOpen(true);
        } else {
            dispatch(resetEditStockUpdate()); // Reset state on cancel
            navigate(-1, { replace: true });
        }
    };

    const handleFieldChange = (field, value) => {
        setHasUnsavedChanges(true);
        setUnsavedChanges(true);
        dispatch(updateStockUpdate({ [field]: value }));
    };

    const handleUpdateQuantityChange = (newValue) => {
        // Use a regular expression to allow only numbers
        const numericValue = newValue.replace(/[^0-9]/g, '');

        handleFieldChange('updateQuantity', numericValue);

        if (numericValue) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                updateQuantity: false,
            }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                updateQuantity: "",
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                updateQuantity: true,
            }));
            setErrorMessages((prevMessages) => ({
                ...prevMessages,
                updateQuantity: "Update Quantity is required",
            }));
        }
    };


    const handleCostPerPiecesChange = (newValue) => {
        handleFieldChange('costPerPieces', newValue);
    };


    const handleRemarksChange = (newValue) => {
        handleFieldChange('remarks', newValue);
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleCancelDialogConfirm = () => {
        setCancelDialogOpen(false);
        navigate(-1, { replace: true });
    };

    return (
        <>
            <DefaultCard sx={{ height: "100%" }}>
                <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                    <Box mb={2}>
                        <Grid container gap={3}>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Item Code"
                                    id="item-code"
                                    value={itemcode}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Item Description"
                                    id="item-code"
                                    value={itemCodeDesc}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    maxlength={10}
                                    label="Update Quantity"
                                    id="update-quantity"
                                    value={stockUpdate.updateQuantity}
                                    placeholder={"Enter Number"}
                                    onChange={(e) => handleUpdateQuantityChange(e)}
                                    disabled={isViewMode}
                                    isMandatoryField
                                    error={errors.updateQuantity}
                                    errorMessage={errorMessages.updateQuantity}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    maxlength={40}
                                    label="Cost per pieces(RM)"
                                    id="cpp"
                                    value={stockUpdate.costPerPieces}
                                    onChange={(e) => handleCostPerPiecesChange(e)}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    maxlength={255}
                                    label="Remarks"
                                    id="remarks"
                                    value={stockUpdate.remarks}
                                    onChange={(e) => handleRemarksChange(e)}
                                    disabled={isViewMode}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                {isViewMode ? (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button variant="outlined" sx={{ m: 1 }} onClick={handleCancel}>
                            Back
                        </Button>
                    </Box>
                ) : (
                    <CustomFooter
                        cancelClick={handleCancel}
                        saveClick={handleSubmit}
                        buttonLabel="Update"
                    />
                )}
                <CustomDialog
                    open={successDialogOpen}
                    onClose={() => setSuccessDialogOpen(false)}
                    content={succesDialogMessage}
                    confirmBtn="OK"
                    onConfirm={() => setSuccessDialogOpen(false)}
                />
                <CustomDialog
                    open={cancelDialogOpen}
                    onClose={handleCancelDialogClose}
                    content="Record(s) not Saved/Updated. Do you want to continue?"
                    confirmBtn="Yes"
                    cancelBtn="No"
                    onConfirm={handleCancelDialogConfirm}
                    onCancel={handleCancelDialogClose}
                />
            </DefaultCard>
        </>
    );
};

export default StockUpdateEditTab;
